import './georgetown4/style';
import FormStructure from './georgetown4/form_structure';

export default FormStructure;